import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import AddNew from './AddGovAddress'
import { addcontext } from '../../ContextShare/ContextShare';
import ChangeSeq from './ChangeseqGa';
import { DeleteGovAddress, EditGovAddress, GetEvent, GetKlaListForSearchFilter, GetSessionListTableWithKLA, MembersList, GovAddressListAdmin, hideGovAddress, GetSessionListForSearchFilterWithKla, GetSessionListForSearchFilter, FiterGOVTableAdmin, searchVideoAdmin, updatePartOrderGV } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
// import Select from "react-select";
import ViewVideo from '../Video/ViewVideo';
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import AddTimeline from '../AdminHome.jsx/AddTimeline';
import EditOrAddTags from '../AdminHome.jsx/EditOrAddTags';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import Select, { components } from 'react-select';
import { useNavigate } from 'react-router-dom';
import AddThumb from '../Video/AddThumb';
import { toast, ToastContainer } from 'react-toastify';
import '../Video/TableVideo.css'
import YoutubeLinkAdd from '../Video/YoutubeLinkAdd';
import AdminPagination from '../../Components/AdminPagination';

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;

    if (data.value === 'addnewkla' || data.value === 'addnewsession') {
        return (
            <div
                className='hover:bg-green-500 hover:text-white text-green-500'
                ref={innerRef}
                {...innerProps}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    // backgroundColor: 'lightyellow',
                    padding: '10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                <span className='font-bold' >{data.label}</span>
                <Icon icon="basil:add-outline" className='ms-1 font-bold' />

            </div>
        );
    }

    return <components.Option {...props} />;
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable
};
const styleThum = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable
};
const style3 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleT = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'hidden' // Make the Box scrollable
};

function TableGovAddress() {
    const { changeSeqNoGA, setChangeSeqNoGA } = useContext(addcontext)
    const { addGovAddress, setaddGovAddress } = useContext(addcontext)
    const { GASearchQuery, setGASearchQuery } = useContext(addcontext)
    const [token, setToken] = useState()
    const [videoData, setVideoData] = useState([])
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const [klaoptions, setKlaOptions] = useState([]);
    const [dataToThumb, setDataToThumb] = useState()
    const [errorSearch, setErrorSearch] = useState()
    const [mapIdToYt, setMapIdToYt] = useState()
    const [hideButtonClicked, setHideButtonClicked] = useState(false)
    const { paginationStartIndexAD, setPaginationStartIndexAD } = useContext(addcontext)
    const { paginationEndIndexAD, setPaginationEndIndexAD } = useContext(addcontext)
    const [isFiltered, setIsFiltered] = useState(false)
    const [refreshPagination, setRefreshPagination] = useState(false)
    const [videoCount, setVideoCount] = useState()
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setDataToEdit()
    }
    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [klaListF, setKlaListF] = useState([]);
    const [sessionListF, setSessionListF] = useState([]);
    const [open2, setOpen2] = useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => {
        setOpen2(false);
        setDataToEdit()
    }

    const [open3, setOpen3] = useState(false);
    const handleOpen3 = () => setOpen3(true);
    const handleClose3 = () => {
        setOpen3(false);
        // setDataToEdit()
    }
    const navigate = useNavigate()
    const [idToDelete, setidToDelete] = useState()
    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }

    const [openTag, setOpenTag] = useState(false);
    const handleOpenTag = () => {
        // setIdToTag(IdToDlt)
        setOpenTag(true);
    }
    const handleCloseTag = () => {
        setOpenTag(false);
        // setDataToEdit()
    }

    const [openTL, setOpenTL] = useState(false);
    const handleOpenTL = () => {
        // setIdToTag(IdToDlt)
        setOpenTL(true);
    }
    const handleCloseTL = () => {
        setOpenTL(false);
        // setDataToEdit()
    }
    const [open5, setOpen5] = useState(false);
    const handleOpen5 = () => setOpen5(true);
    const handleClose5 = () => {
        setOpen5(false);
        setDataToThumb()
    }
    const [open6, setOpen6] = useState(false);
    const handleOpen6 = () => setOpen6(true);
    const handleClose6 = () => {
        setOpen6(false);
        setDataToThumb()
    }

    const [klaList, setKlaList] = useState([])
    const [SessionList, setSessionList] = useState([])
    const [sessionOptions, setSessiOnoptions] = useState([]);
    const [eventList, setEventList] = useState([])
    const [eventOptions, setEventOptions] = useState([]);
    const [memberList, setMemberList] = useState([])
    const [memberOptions, setMemberOptions] = useState([]);
    const [videDataToPlay, setVideDataToPlay] = useState()
    const [idToTag, setIdToTag] = useState()
    const [idToTL, setidToTL] = useState()
    const [errorMsg, setErrorMsg] = useState()

    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            if (!isFiltered) {
            if (!GASearchQuery) {
                GetVideoData()
            }}
        }
        else {
            console.log("token fetching failed");
        }
    }, [token, isEdited, addGovAddress,paginationStartIndexAD, paginationEndIndexAD])
    const GetVideoData = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await GovAddressListAdmin(reqHeader,paginationStartIndexAD ?? 1, paginationEndIndexAD ?? 25)
        console.log(result);
        setVideoData(result?.data?.data)
        setErrorSearch(result?.response?.data?.message)
        setVideoCount(result?.data?.count)
    }
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
            },
        },

        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
            minWidth: '70px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '80px',
        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,
            minWidth: '80px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '90px',
        },
        {
            name: 'Video URL',
            selector: row => row.url,
            sortable: true,
            minWidth: '140px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '180px',
        },
        {
            name: 'Edit',
            selector: row => row.Action,
            // sortable: true,
            minWidth: '110px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '120px'
        },
        {
            name: 'Action',
            selector: row => row.Visible,
            sortable: true,
            minWidth: '130px',
            maxWidth: '140px',
        },
        {
            name: 'Details',
            selector: row => row.KLA,
            sortable: true,
            minWidth: '140px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '150px',
        },
        // {
        //     name: 'Thumbnail',
        //     selector: row => row.thumb,
        //     // sortable: true,
        //     minWidth: '140px', // Adjust the width as needed
        //     // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
        //     maxWidth: '150px',
        // },
        // {
        //     name: 'Seq no',
        //     selector: row => row.seqno,
        //     sortable: true,
        // },
        // {
        //     name: 'KLA',
        //     selector: row => row.KLA,
        //     sortable: true,
        // },
        // {
        //     name: 'Session',
        //     selector: row => row.Session,
        //     sortable: true,
        // },
        {
            name: 'Event',
            selector: row => row.Event,
            sortable: true,
            minWidth: '140px', // Adjust the width as needed
            maxWidth: '150px'
        },
        {
            name: 'Member',
            selector: row => row.Member,
            sortable: true,
            minWidth: '140px', // Adjust the width as needed
            maxWidth: '150px'
        },
        {
            name: 'Subject',
            selector: row => row.title,
            sortable: true,
            minWidth: '160px', // Adjust the width as needed
            maxWidth: '200px'
        },
        {
            name: 'Date',
            selector: row => row.Date,
            sortable: true,
            minWidth: '90px', // Adjust the width as needed
            maxWidth: '100px',
        },
        {
            name: 'Part',
            selector: row => row.ParentId,
            sortable: true,
            minWidth: '100px', // Adjust the width as needed
            maxWidth: '110px'
        },
       
        // {
        //     name: 'Part Order',
        //     selector: row => row.PartOrder,
        //     sortable: true,
        // },
        // {
        //     name: 'Uploader',
        //     selector: row => row.UploadedBy,
        //     sortable: true,
        // }, {
        //     name: 'Created at',
        //     selector: row => row.CreatedAt,
        //     sortable: true,
        // },
        // {
        //     name: 'Updated at',
        //     selector: row => row.UpldatedAt,
        //     sortable: true,
        // },

        // {
        //     name: 'Edit',
        //     selector: row => row.Action,
        //     // sortable: true,
        // },
        // {
        //     name: 'Tag',
        //     selector: row => row.tag,
        //     // sortable: true,
        // },
        // {
        //     name: 'Timeline',
        //     selector: row => row.timeline,
        //     // sortable: true,
        // },
        // {
        //     name: 'Visible',
        //     selector: row => row.Visible,
        //     sortable: true,
        //     minWidth: '120px', // Adjust the width as needed
        //     // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
        //     maxWidth: '140px',
        // },
        {
            name: 'Delete',
            selector: row => row.active,
            sortable: true,
            minWidth: '80px', // Adjust the width as needed
            maxWidth: '90px',
        }
        // {
        //     name: 'Action',
        //     selector: row => row.ActionPart,
        //     // sortable: true,
        // },
    ];
    const hideOrUnhide = async (item) => {
        setHideButtonClicked(true)
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await hideGovAddress({ pk: item?.video_id }, reqHeader)
        if (response.status == 200) {
            // console.log(response);
            setIsEdited(isEdited + 1)
            setTimeout(() => {
                setHideButtonClicked(false)
            }, 1000)
            toast.success(item?.is_visible ? "Video hided sucessfully" : "video unhided")
        } else {
            toast.error(response?.response?.data?.message ?? "There was problem updating the visibility!!!")
        }
    }

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteGovAddress(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }
    const handleMapCopy = (e) => {
        if (navigator.clipboard && window.isSecureContext) {
            // Navigator clipboard API method'
            navigator.clipboard.writeText(e).then(() => {
                toast.info('Text copied to clipboard');
            }).catch((err) => {
                console.error('Failed to copy text: ', err);
            });
        } else {
            // Fallback method using a temporary textarea element
            let textArea = document.createElement("textarea");
            textArea.value = e;
            // Avoid scrolling to bottom
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                toast.info('Text copied to clipboard');
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }
            document.body.removeChild(textArea);
        }
    };

    var data = []
    // for (let i = 0; i < 200; i++) {
    videoData?.length > 0 && videoData?.map((item, index) => {
        // const idtemp = index + 1; // Assuming ids start from 1
        const slno = index + 1;
        const id = <div className='containerId flex flex-col justify-between w-full h-full '>
            <div className='flex flex-row gap-3 items-center'><span>{item.video_id}</span><button onClick={() => handleVidePlay(item)} className='text-blue-500 hover:text-blue-800 '><Icon icon="iconamoon:link-external-bold" className='text-lg' /></button></div>
            <span className='mapId text-blue-800 text-xs mt-3 cursor-pointer' title={item?.mapping_id}>{item?.mapping_id}</span>
            <div className='mapCopy flex flex-row gap-2 items-center mt-3 bg-blue-500 px-1 rounded text-white cursor-pointer' onClick={() => handleMapCopy(item?.mapping_id)}><span>Copy</span><Icon icon="icon-park-solid:copy-link" /></div>

        </div>
        const seqno = item.video_sequence_no;
        const KLA = <div className='flex flex-col justify-start items-start gap-1'>
            <span>sequence No: {item?.video_sequence_no}</span>
            <span  className='text-yellow-900 font-semibold'>Kla: {item?.kla}</span>
            <span  className='text-yellow-900 font-semibold'>Session: {item?.video_session}</span>
        </div>
        const Session = item.video_session;
        const Event = item.video_event;
        const Member = <div className='flex flex-col gap-0.5'>
        {item?.video_member?.map((mem)=>(
            <span>{mem}</span>
        ))}
    </div>
        const title = (
            <div className=" flex justify-start ">
              <p className="text-wrap flex ">
                {item.video_subject}
              </p>
            </div>
          );
          const url = (
            <div className="flex justify-start">
            <p className="flex text-wrap flex-col ">
              {item.video_url.split('/').slice(0, -1).join('/')}/
              <span className="text-yellow-900 font-bold ">
                {item.video_url.split('/').pop()}
              </span>
            </p>
          </div>
          
          );      
        const Date = item.video_upload_date?.split('-')?.reverse()?.join('-');
        const ParentId = <div className='flex flex-col justify-start items-start gap-1'>
            <span>Parent: {item.parent_video}</span>
            <span>Part order: {item.part_order}</span>

        </div>
        const PartOrder = item.part_order;
        // const UploadedBy = item.uploaded_by;
        const CreatedAt = item.created_at?.slice(0, 10);
        const UpldatedAt = item.updated_at?.slice(0, 10);
        // Define icons based on the value of item.is_visible
        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.video_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>
        
        const Visible =
            <div className='flex flex-col justify-center items-center gap-1 py-1'>
                <div className='flex flex-row justify-between items-center w-24  '>
                    <Icon icon={`${item.is_visible ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item.is_visible ? 'green' : 'red'}` }} className='text-lg' />
                    <button onClick={() => hideOrUnhide(item)} className='ms-2 text-white px-4 py-1 rounded w-16' style={{ backgroundColor: '#18A0FB', cursor: `${hideButtonClicked ? 'wait' : 'pointer'}` }} >{item.is_visible ? 'Hide' : 'Unhide'}</button>
                </div>
                <button className='w-24 py-1 text-white rounded' style={{ backgroundColor: '#18A0FB' }} onClick={() => handleTags(item.mapping_id)}>Update Tags</button>
                <button className='w-24 py-1 text-white rounded ' style={{ backgroundColor: '#18A0FB' }} onClick={() => handleThumb(item)}>Update thumbnail</button>
                <button className={`w-24 py-1 text-white rounded flex flex-row items-center gap-1 justify-center bg-lblue`} onClick={() => handleYtLink(item)}> <span>Youtube Link</span> {item?.youtube_link && <Icon icon='fa-solid:check-circle' className='text-sm ' />}</button>

            </div>

        const Action = <div className='flex flex-col gap-1 justify-center items-center'>
            <a style={{cursor: 'pointer' }} className='flex flex-row gap-1 items-center text-blue-500 border border-blue-500 rounded w-16 justify-center py-0.5 hover:bg-lblue hover:text-white' onClick={() => handleEdit(item)}> <span className=''>Edit</span><Icon icon="bxs:edit" className='' /></a>
            {item.part_order && <a className=' w-16 flex justify-center py-0.5 border border-blue-500 rounded text-blue-500 hover:bg-lblue hover:text-white' style={{cursor: 'pointer' }} onClick={() => handleEditParentVideos(item)}>Edit part</a>}</div>

        const tag = <button className='px-2 py-1 text-white rounded' style={{ backgroundColor: '#18A0FB' }} onClick={() => handleTags(item.mapping_id)}>Add / Edit</button>;
        const timeline = <button className='px-2 py-1 text-white rounded' style={{ backgroundColor: '#18A0FB' }} onClick={() => handleTimeline(item.video_id)}>Add / Edit</button>;
        const ActionPart = item.parent_video && <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit part</a>;
        const thumb = <button className='px-2 py-1 text-white rounded' style={{ backgroundColor: '#18A0FB' }} onClick={() => handleThumb(item)}>Update thumbnail</button>;
        const ytAdd = <button className='px-2 py-1 text-white rounded bg-red-300' onClick={() => handleYtLink(item)}>Youtube Link</button>;



        const newObj = { id, seqno, slno, title,url, KLA, Session, Event, Member, Date, ParentId, PartOrder, CreatedAt, UpldatedAt, thumb, active, Visible, Action, tag, timeline, ActionPart };
        data.push(newObj);
    })
    // }
    const handleYtLink = (item) => {
        handleOpen6()
        setMapIdToYt(item?.mapping_id)
    }

    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()
        klaListCallApi();
        EventListApi()
        MemberListApi()


    }
    const handleThumb = (item) => {
        setDataToThumb(item)
        handleOpen5()
    }

    useEffect(() => {
        klaListCallApi();
        EventListApi()
        MemberListApi()
    }, []);

    useEffect(() => {
        if (dataToEdit) {
            SessionListCallApi();
        }
    }, [dataToEdit]);

    useEffect(() => {
        if (dataToEdit) {
            SessionListCallApi();
        }
    }, [dataToEdit?.kla]);

    useEffect(() => {

        MemberListApi();

    }, [dataToEdit?.video_session]);


    // Inside klaListCallApi:
    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            const options = result?.data?.data.map(item => ({
                value: item.kla_id,
                label: `KLA${item.kla_no}`,
                valueApi: item.kla_no
            }));
            setKlaList(result?.data?.data);
            setKlaOptions(options);
        } catch (error) {
            console.error("Error fetching Kla list for filter:", error);
        }
    };

    // Inside SessionListCallApi:
    const SessionListCallApi = async () => {
        try {
            const klaId = dataToEdit?.kla?.value || dataToEdit?.kla_id;
            if (!klaId) return; // Exit if klaId is not available
            const result = await GetSessionListTableWithKLA({ kla: klaId });
            const options = result?.data?.data.map(item => ({
                value: item.session_id,
                label: `Session${item.session_no}`,
                valueApi: item.session_no
            }));
            setSessionList(result?.data?.data);
            setSessiOnoptions(options);
        } catch (error) {
            console.error("Error fetching session list for filter:", error);
        }
    };

    // Inside EventList:
    const EventListApi = async () => {
        try {
            const result = await GetEvent();
            // console.log(result);
            const options = result?.data?.data.map(item => ({
                value: item.event_id,
                label: item.event_name,
                valueApi: item.event_name
            }));
            setEventList(result?.data?.data);
            setEventOptions(options);
        } catch (error) {
            console.error("Error fetching event list for filter:", error);
        }
    };

    // Inside MemberList:
    const MemberListApi = async () => {
        try {
            const token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const sessionId = dataToEdit?.video_session?.value || dataToEdit?.session_id;
            if (!sessionId) return; // Exit if klaId is not available
            const result = await MembersList({ session_id: sessionId }, reqHeader);
            console.log(result);
            const options = result?.data.map(item => ({
                value: item.id,
                label: ` ${item?.member_name} as ${item?.role}`,
                valueApi: item?.member_name
            }));
            setMemberList(result?.data);
            setMemberOptions(options);
        } catch (error) {
            console.error("Error fetching event list for filter:", error);
        }
    };


    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };

        dataToEdit.kla = dataToEdit?.kla?.valueApi ? dataToEdit?.kla?.valueApi : dataToEdit?.kla
        dataToEdit.video_event = dataToEdit?.video_event?.valueApi ? dataToEdit?.video_event?.valueApi : dataToEdit?.video_event
        dataToEdit.video_session = dataToEdit?.video_session?.valueApi ? dataToEdit?.video_session?.valueApi : dataToEdit?.video_session

        var videoNewMemberId = dataToEdit?.video_member?.map((item) => {
            return item.value
        })
        dataToEdit.video_member = dataToEdit?.video_member[0]?.label ? videoNewMemberId : dataToEdit?.member_id

        console.log(dataToEdit);
        const result = await EditGovAddress(dataToEdit, reqHeader)
        if (result.status == 200) {
            toast.success("Editing successfull")
            console.log(result);
            handleClose()
            setIsEdited(isEdited + 1)
        } else {
            toast.error(result?.response?.data?.message ?? "There was problem editing!!!")
        }
    }
    const handleFileUpload = (e) => {
        const files = e.target.files[0];
        // dataToEdit.video_url=files.name
        // console.log(files.name);
        if (files) {
            setDataToEdit({ ...dataToEdit, video_url: files.name })
        }
    }

    const handleEditParentVideos = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen2()



    }
    const handleSubmitEditPartVideos = async () => {
        console.log(dataToEdit);
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const videoId = dataToEdit?.video_id
        const newpart = Number(dataToEdit?.part_order)
        const res = await updatePartOrderGV({ part_order: newpart }, reqHeader, videoId)
        if (res.status == 200) {
            toast.success("Editing successfull")
            GetVideoData()
            handleClose2()
        } else {
            toast.error(res?.response?.data?.message ?? "There was problem editing!!!")
        }

    }

    const handleVidePlay = (videdetailsone) => {
        handleOpen3()
        setVideDataToPlay(videdetailsone)
    }
    // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApiFilter = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionListF(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApiFilter();
    }, [selectedOptionKla]);

    const sessionoptionsF = sessionListF.map((item) => ({
        value: item.session_id,
        label: `Session${item.session_no}`,
    }));

    const handlechange = (option) => {
        if (option?.value == 'addnewkla') {
            navigate('/octobersky/kla')
        }
        else {
            setSelectedOptionKla(option)
            setIsFiltered(true)
            setPaginationStartIndexAD(1)
            setPaginationEndIndexAD(25)
            setRefreshPagination(true)
        }
    }
    const handlechangesession = (option) => {
        if (option?.value == 'addnewsession') {
            navigate('/octobersky/session')
        }
        else {
            setSelectedOptionsession(option);
            setIsFiltered(true)
            setPaginationStartIndexAD(1)
            setPaginationEndIndexAD(25)
            setRefreshPagination(true)
        }
    }

    const FilterAdminVideoTable = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        // const member_id = selectedOptionMember?.value;
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        // if (member_id) obj.member_id = member_id;
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FiterGOVTableAdmin(obj, reqHeader,paginationStartIndexAD, paginationEndIndexAD);
            setVideoData(result?.data?.data || []);
            setErrorSearch(result?.response?.data?.message)
            setVideoCount(result?.data?.count)
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession) {
            if (isFiltered) {
                FilterAdminVideoTable()
            }
        }
    }, [selectedOptionKla, selectedOptionsession,paginationStartIndexAD, paginationEndIndexAD,isEdited]);

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------
    const handleTags = (vID) => {
        setIdToTag(vID)
        handleOpenTag()
    }

    const handleTimeline = (VID) => {
        setidToTL(VID)
        handleOpenTL()
    }

    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setGASearchQuery('')
        GetVideoData()
        setPaginationStartIndexAD(1)
        setPaginationEndIndexAD(25)
        setRefreshPagination(false)
        setErrorMsg()
        // setSelectedOptionsession(null)
        // GetProgressList()

    }
    useEffect(() => {
        if (GASearchQuery) {
            // console.log('hi');
            handlesearch()
        }
    }, [GASearchQuery])
    const handlesearch = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        if (GASearchQuery) {
            const res = await searchVideoAdmin({ id: GASearchQuery }, reqHeader)
            console.log(res);

            setVideoData(res?.data?.data)
            setErrorSearch(res?.response?.data?.message)
            if (res?.data?.data) {
                if (res?.data?.type != 'Governor-address') {
                    toast.warning('Search by Governers address mapping id')
                    GetVideoData()
                }
            }
        }
    }

    return (
        <>

            {addGovAddress ? <AddNew />
                : changeSeqNoGA ? <ChangeSeq />
                    :
                    <>
                        <div className='flex flex-row justify-center gap-5'>

                            <div className='flex flex-col w-3/12  text-blue-400'>
                                {/* <div style={{visibility:'hidden'}}>Start date</div> */}

                                <div className='flex flex-row justify-between rounded-lg items-center'>
                                    <input
                                        placeholder='Search by Mapping ID'
                                        className='w-full h-9 p-2 outline-none focus:outline-none border-t border-b border-s rounded-s-lg border-gray-400 placeholder:text-gray-600'
                                        value={GASearchQuery}
                                        onChange={(e) => setGASearchQuery(e.target.value)}
                                    />
                                    <div onClick={handlesearch} className='hover:text-white font-bold text-lg border hover:bg-blue-500 text-blue-500 border-blue-500 h-full flex items-center justify-center rounded-r-lg w-10 cursor-pointer'> <Icon icon="ion:search" /></div>
                                </div>

                            </div>
                            <div className='flex flex-row w-32  text-blue-400'>

                                <Select
                                    placeholder='KLA'
                                    className='w-full'
                                    options={[...klaoptionsF, { value: 'addnewkla', label: 'Add new kla' }]}
                                    value={selectedOptionKla}
                                    onChange={handlechange}
                                    components={{ Option: CustomOption }}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        }),
                                    }}

                                />
                            </div>

                            <div className='flex flex-row w-32 text-blue-400'>
                                <Select
                                    placeholder='Session'
                                    className='w-full'
                                    options={[...sessionoptionsF, { value: 'addnewsession', label: 'Add new session' }]}
                                    value={selectedOptionsession}
                                    onChange={handlechangesession}
                                    components={{ Option: CustomOption }}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        }),
                                    }}

                                />
                            </div>

                            <div className='flex flex-col '>
                                <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 bg-white border text-red-600 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                    <span>Clear Filter</span>
                                    <Icon icon="bx:reset" />
                                </button>
                            </div>

                        </div>
                        <>
                            {videoData?.length > 0 ?
                                <div className='flex flex-col gap-1'>
                                <DataTable
                                    title={<div className='flex flex-row items-center'><span className='me-2'>Governer's Address List</span> <PopOver dataToDisplay={'Add Edit Governers address'} /></div>}
                                    columns={columns}
                                    data={data}
                                    customStyles={customStyles}
                                    // pagination
                                    dense
                                    highlightOnHover
                                    selectableRowsHighlight
                                    paginationPerPage={50} // Initial page size
                                    paginationRowsPerPageOptions={[50, 100, 200, 500]} // Options for users to change page size
                                // selectableRows
                                // progressPending
                                // progressComponent={<h1>load</h1>}
                                />
                                {videoCount > 25 && <AdminPagination count={videoCount} refresh={refreshPagination} />}
                                </div>
                                :

                                <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                    {!errorSearch ? <>
                                        <SyncLoader
                                            color="#3498db"
                                            loading={true}
                                            speedMultiplier={1}
                                        />
                                        <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p
                                        ></>
                                        :
                                        <p className="text-red-500 flex flex-row items-center"><span>{errorSearch}</span></p>

                                    }

                                </div>}
                        </>
                    </>
            }


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <p className='text-blue-500'>Video Id: {dataToEdit?.video_id}</p>
                        {/* Additional fields */}
                        {/* <div className='w-10/12'>
                            <p className='text-blue-500 w-full text-center mt-5 break-words overflow-wrap break-word' style={{ wordBreak: 'break-all' }}>
                                {dataToEdit?.video_url}
                            </p>
                        </div> */}

                        {/* <div className='w-10/12 flex flex-col mt-2 bg-success h-20 rounded-lg border border-dashed border-gray-700 px-2'>
                            <label htmlFor="fieldurl">
                                <input
                                    style={{ visibility: 'hidden' }}
                                    id='fieldurl'
                                    // value={dataToEdit?.video_url}
                                    // onChange={(e) => setDataToEdit({ ...dataToEdit, video_url: e.target.files[0] })}
                                    onChange={(e) => handleFileUpload(e)}
                                    type="file"
                                // className='bg-red-500'

                                />
                                <div className='w-full flex justify-center flex-row items-center text-blue-500'>
                                    <p className=' underline me-2'> Click here to upload file </p>
                                    <Icon icon="lets-icons:upload" />
                                </div>
                            </label>
                        </div> */}
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="fieldurl">Video Url
                            </label>
                            <input
                                value={dataToEdit?.video_url}
                                className=' bg-success w-full h-20 rounded-lg border border-dashed border-gray-700 px-2'
                                id='fieldurl'
                                onChange={(e) => setDataToEdit({ ...dataToEdit, video_url: e.target.value })}
                                type="text"
                            // className='bg-red-500'
                            />
                        </div>


                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla">KLA</label>
                            <Select
                                id='kla'
                                placeholder={dataToEdit?.kla}
                                options={klaoptions}
                                value={dataToEdit?.kla}
                                onChange={option => setDataToEdit({ ...dataToEdit, kla: option })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla">Session</label>
                            <Select
                                id='kla'
                                placeholder={dataToEdit?.video_session}
                                options={sessionOptions}
                                value={dataToEdit?.video_session}
                                onChange={option => setDataToEdit({ ...dataToEdit, video_session: option })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla">Event</label>
                            <Select
                                id='kla'
                                placeholder={dataToEdit?.video_event.length > 31 ? dataToEdit.video_event?.slice(0, 31) + '...' : dataToEdit?.video_event}
                                options={eventOptions}
                                value={dataToEdit?.video_event}
                                onChange={option => setDataToEdit({ ...dataToEdit, video_event: option })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla">Member</label>
                            <Select
                                isMulti
                                id='kla'
                                placeholder={dataToEdit?.video_member}
                                options={memberOptions}
                                value={dataToEdit?.video_member.forEach((item) => { return item })}
                                onChange={option => setDataToEdit({ ...dataToEdit, video_member: option })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Subject</label>
                            <input
                                id='field3'
                                value={dataToEdit?.video_subject}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, video_subject: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Subject malayalam</label>
                            <input
                                id='field3'
                                value={dataToEdit?.mal_video_subject}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, mal_video_subject: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Date</label>
                            <input
                                id='field3'
                                value={dataToEdit?.video_upload_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, video_upload_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={open2}
                onClose={handleClose2}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <p className='text-blue-500'>Video Id: {dataToEdit?.video_id}</p>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Part order</label>
                            <input
                                id='field3'
                                value={dataToEdit?.part_order}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, part_order: e.target.value })}
                                type="number"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>


                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEditPartVideos}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose2}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={open3}
                onClose={handleClose3}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style3}>
                    <ViewVideo videoData={videDataToPlay} handleCloseM={handleClose3}/>
                </Box>
            </Modal>

            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>

            <Modal
                open={openTag}
                onClose={handleCloseTag}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleT}>
                    <EditOrAddTags videoId={idToTag} handleCloseModalSS={handleCloseTag} whichPage={'ga'} />
                </Box>
            </Modal>

            <Modal
                open={openTL}
                onClose={handleCloseTL}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleT}>
                    <AddTimeline handleCloseModalTL={handleCloseTL} videoId={idToTL} />
                </Box>
            </Modal>

            <Modal
                open={open5}
                onClose={handleClose5}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleThum}>
                    <AddThumb data={dataToThumb} close={handleClose5} which={'ga'} setIsEdited={setIsEdited} />
                </Box>
            </Modal>

            <Modal
                open={open6}
                onClose={handleClose6}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleThum}>
                    <YoutubeLinkAdd mapId={mapIdToYt} close={handleClose6} setIsEdited={setIsEdited} />
                </Box>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}

export default TableGovAddress